import { Header } from '../components/Header';
import { CrmMessageTemplatesPanel } from '../components/crm/CrmMessageTemplatesPanel';

export function CrmTemplatesPage() {
  return (
    <>
      <Header
        title="Templates de Mensagens"
        subtitle="Biblioteca de mensagens pronta para WhatsApp, e-mail e cópia rápida."
      />
      <div className="p-6">
        <CrmMessageTemplatesPanel />
      </div>
    </>
  );
}
